/**
 * Created by tofael on 3/23/17.
 */

export function setAuthUser(data) {
  localStorage.setItem('_a', JSON.stringify(data.user));
  localStorage.setItem('token', data.token);
}

export function isUserAuthenticated() {
  return localStorage.getItem('_a') !== null;
}

export function removeAuthUser() {
  localStorage.removeItem('_a');
  localStorage.removeItem('token');
}

export function getToken() {
  return localStorage.getItem('token');
}

export function getUser() {
  return JSON.parse(localStorage.getItem('_a'));
}

export function setListUIPreference(listName, preference) {
  localStorage.setItem(listName, JSON.stringify(preference));
}

export function getListUIPreference(listName) {
  let preference = localStorage.getItem(listName);
  return preference ? JSON.parse(preference) : null;
}


// WEBPACK FOOTER //
// ./src/utility/local-storage.js